import * as React from 'react'
import { useTranslation } from '~/hooks/useTranslation'

export function CostCell({ row }) {
  const { t } = useTranslation('CostCell')
  const savedCourse = row.original
  const cost = savedCourse.free
    ? t('free')
    : `${savedCourse.currency} ${savedCourse.price}`

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="text-normal line-clamp-1 font-bold">{cost}</div>
    </div>
  )
}
